import React, { useEffect } from 'react';
import Header from '../components/header/header';
import Footer from '../components/footer/footer';
import $ from 'jquery';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './AboutUs.css'; // reuse same styles

const TermsOfService = () => {
  useEffect(() => {
    // Smooth scroll
    var html_body = $('html, body');
    $('.navbar a , .scroll-down a , .backtotop a').on('click', function () {
      if (window.location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && window.location.hostname === this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
          html_body.animate({
            scrollTop: target.offset().top - 65
          }, 1500);
          return false;
        }
      }
    });

    // Preloader
    $(window).on('load', function () {
      $('.preloader').delay(1000).fadeOut(1000);
    });
    setTimeout(() => {
      $('.preloader').fadeOut(1000);
    }, 2000);
  }, []);

  return (
    <>
      <Header />
      <div className="container-fluid about-us-container">
        <div className="preloader">
          <div className="frame">
            <div className="center">
              <div className="dot-1"></div>
              <div className="dot-2"></div>
            </div>
          </div>
        </div>

        <section id="terms-of-service-page" className="about-us-section">
          <div className="design-layer"></div>
          <div className="backtotop">
            <a href="#terms-of-service-page"><i className="fa fa-arrow-up" aria-hidden="true"></i></a>
          </div>

          <div className="container zindex">
            <div className="about-hero">
              <h3>Terms of <span className="highlight">Service</span></h3>
              <p>These Terms govern your use of our services. Please read them carefully before using our platform.</p>
            </div>

            <div className="about-content-section">
              <div className="about-card">
                <h2 className="about-section-title">
                  <i className="fa fa-check-square about-icon"></i> Acceptance of Terms
                </h2>
                <p>By accessing or using our services, you agree to be bound by these Terms of Service.</p>
              </div>

              <div className="about-card">
                <h2 className="about-section-title">
                  <i className="fa fa-briefcase about-icon"></i> Service Description
                </h2>
                <p>We provides customer Refmex collection and analytics services through POS integration and web interfaces.</p>
              </div>

              <div className="about-card">
                <h2 className="about-section-title">
                  <i className="fa fa-user about-icon"></i> User Responsibilities
                </h2>
                <ul className="about-feature-list">
                  <li><i className="fa fa-check-circle check-style"></i> Provide accurate registration information</li>
                  <li><i className="fa fa-check-circle check-style"></i> Maintain confidentiality of your account</li>
                  <li><i className="fa fa-check-circle check-style"></i> Not use the service for illegal purposes</li>
                </ul>
              </div>

              <div className="row about-card-group">
                <div className="col-md-6">
                  <div className="about-card flex-grow-1">
                    <h2 className="about-section-title">
                      <i className="fa fa-credit-card about-icon"></i> Payment and Billing
                    </h2>
                    <p>Paid plans are billed monthly or annually. All fees are non-refundable except as required by law.</p>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="about-card flex-grow-1">
                    <h2 className="about-section-title">
                      <i className="fa fa-ban about-icon"></i> Termination
                    </h2>
                    <p>We may terminate or suspend access to our service immediately for violations of these terms.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default TermsOfService;
